<template>
	<div class="form-input">
		<!-- Text block w/ label -->
		<label :for="_uid" >{{title}}</label>
		<div :class='{focus: focussed, "input-block": true, disabled }'>
			<div class="prefix" v-if='prefix'>{{prefix}}</div>
			<div class="spacer" v-if='!prefix'>&nbsp;</div>
			<input
				:id="_uid"
				:placeholder='placeholder'
				ref="item"
				:name="name"
				:autocomplete="autocomplete"
				:value="value"
				@input="update()"
				@focus="onFocus()"
				@blur="offFocus()"
				:disabled="disabled"
				type="text"
			required>
		</div>
	</div>
</template>

<script>

export default {
	name: "FormInput",
	props: {
		value: {
			default: ""
		},
		required: {
			default: false
		},
		prefix: {
			default: false
		},
		disabled: {
			default: false
		},
		scrub: {
			default: true
		},
		title: {
			default: ""
		},
		name: {
			default: "input"
		},
		autocomplete: {
			default: ""
		},
		placeholder: {
			default: ""
		},
		hint: {
			default: ""
		}
	},
	data(){
		return {
			focussed: false
		};
	},
	methods: {
		onFocus(){
			this.focussed = true;
		},
		offFocus(){
			this.focussed = false;
		},
		update() {
			this.$refs.item.value = this.$refs.item.value.scrub()//😀
			this.$emit('input', this.$refs.item.value);
		}
	}
};
</script>

<style scoped lang="scss">
	.input-block{
		position: relative;
		display: flex;
		align-items: center;
		color: #919eab;
		cursor: text;
		border: 1px solid #CDCDCD;
		border-radius: 7px;
	}
	label{
		width: 100%;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
		font-size: 18px;
	}
	input{
		position: relative;
		z-index: 20;
		display: block;
		flex: 1 1 0%;
		width: 100%;
		margin: 0;
		padding: 8px 20px 8px 3px;
		background: none;
		border: 1px solid transparent;
		height: 42px;
	}
	input:focus{
		outline: 0px;
	}
	.prefix{
		position: relative;
		z-index: 20;
		text-align: center;
		width: 20px;
		margin-left: 5px;
	}
	.spacer{
		width: 10px;
	}
	.disabled{
		background-color: #EBEBEB;
	}
</style>
